module.exports = __webpack_public_path__ + "static/media/dustbin_icon-white.02430763.svg";